/// <reference path="../../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../../node_modules/@types/jquery.validation/index.d.ts" />
/// <reference path="../../../node_modules/@types/jquery-validation-unobtrusive/index.d.ts" />
/// <reference path="../../../node_modules/@types/typeahead/index.d.ts" />
/// <reference path="../../../node_modules/@types/jquery-mask-plugin/index.d.ts" />
import { Utility } from "../Shared/Utility";
export { Utility } from "../Shared/Utility";
export class Index {

    Initialize(): void {
        Utility.BindSubmitButtonHandler("#index-form", "#submitButton");
        //clear inputs via jQuery if user clicks cancel button
        $("#cancelButton").on('click', (evt) => {
            $("#index-form").trigger("reset");
        });
    }


}

//DOM
((window: any, document: any) => {
    $(() => {
        var index = new Index();
        index.Initialize();

    });
})(window, document);